@if (canAdd) {
  <button
    mat-fab
    color="primary"
    class="!fixed !bottom-20 !right-6 z-10"
    (click)="onAdd()"
    aria-label="Add entity"
  >
    <mat-icon>add</mat-icon>
  </button>
}
@for (card of cards$ | async; track card.id) {
  <mat-card class="m-3 w-96">
    @if (card.image) {
      <img
        mat-card-image
        width="384"
        height="200"
        style="width: 400px; height: 200px"
        [style.object-fit]="card.imageFit || 'cover'"
        [ngSrc]="card.image"
        [alt]="'Photo of ' + card.title"
      />
    }
    <mat-card-header>
      @if (card.avatar) {
        <img
          mat-card-avatar
          [src]="card.avatar"
          [alt]="'Logo of ' + card.title"
          class="rounded object-contain"
        />
      }
      <mat-card-title>{{ card.title }}</mat-card-title>
      <mat-card-subtitle>{{ card.subtitle }}</mat-card-subtitle>
      @if (canEdit || canDelete) {
        <lib-edit-menu
          [canEdit]="canEdit"
          [canDelete]="canDelete"
          (edit)="onEdit(card)"
          (delete)="onDelete(card)"
        ></lib-edit-menu>
      }
    </mat-card-header>
    <mat-card-content>{{ card.description }}</mat-card-content>
    <mat-card-actions>
      <mat-chip-listbox aria-label="Tags">
        @for (chip of card.chips; track $index) {
          <mat-chip-option [selectable]="false" [matTooltip]="chip.name">
            @if (chip.image) {
              <img
                matChipAvatar
                aria-hidden
                [src]="chip.image"
                style="width: 32px; height: 32px; object-fit: contain"
              />
            }
            &nbsp;&nbsp;{{ chip.name }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </mat-card-actions>
  </mat-card>
} @empty {
  @if ((facade.loaded$ | async) === false) {
    <mat-spinner
      class="absolute bottom-[calc(50vh-50px)] right-[calc(50vw-50px)] z-[11]"
    ></mat-spinner>
  }
}
